var condIndex = /\/index\.html?/;
var path = location.pathname.replace(condIndex, '/');
var checks = [path]; // 文字列末尾から 1 ディレクトリずつ削り、URL を収集

while (path && '/' !== path) {
  path = path.replace(/[^/]*\/?$/, '');
  checks.push(path);
} // グローバルナビの href 属性値をすべて取得


var gNavHrefs = $('#headerGlobalNav a').map(function () {
  return $(this).attr('href').replace(condIndex, '/');
}); // ローカルナビの href 属性値をすべて取得

var lNavHrefs = $('.nav-local a').map(function () {
  return $(this).attr('href').replace(condIndex, '/');
}); // console.log(checks);
// console.log(gNavHrefs);
// console.log(lNavHrefs);
// URL と href 属性値の一致を判定

checkGNavStart: for (var i = 0; i < checks.length; i++) {
  for (var j = 0; j < gNavHrefs.length; j++) {
    if (checks[i] === gNavHrefs[j]) {
      var $elem = $('#headerGlobalNav a').eq(j);
      $elem.addClass('-active');
      $elem.parents('li').addClass('-active');
      break checkGNavStart;
    }
  }
}

checkLNavStart: for (var i = 0; i < checks.length; i++) {
  for (var j = 0; j < lNavHrefs.length; j++) {
    if (checks[i] === lNavHrefs[j]) {
      var _$elem = $('.nav-local a').eq(j);

      _$elem.addClass('-active');

      break checkLNavStart;
    }
  }
}